import { createClient } from "@supabase/supabase-js";

/* The two values below come from Supabase -> Project Settings -> API.
   The "anon" key is meant to be public — it is safe in the browser, because
   Row Level Security in supabase/schema.sql decides what it may actually do.
   Never put the "service_role" key in this project. */
const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

/* Until the two variables are set, the site runs in local preview mode:
   data stays in your own browser, exactly as it did before. */
export const isConfigured = Boolean(url && key);

export const supabase = isConfigured ? createClient(url, key) : null;

/* Whether card payments are available is decided by the server at runtime
   (see api.checkCardPayments), so there's no build setting to get right.
   REACT_APP_ENABLE_CARD_PAYMENTS=false still works as an emergency OFF switch
   — for example to pause sales while you're away. Anything else is ignored. */
const cardFlag = String(process.env.REACT_APP_ENABLE_CARD_PAYMENTS || "").trim().toLowerCase();
export const cardPaymentsAllowed = isConfigured && cardFlag !== "false";
